import Badge from "ds/components/Badge";
import { getIntentProjectStateBadgeMeta } from "shared/IntentProject/stateUtils";

type IntentProjectStateBadgeProps = {
  state: string;
};

const IntentProjectStateBadge = ({ state }: IntentProjectStateBadgeProps) => {
  const { variant, label } = getIntentProjectStateBadgeMeta(state);

  return <Badge variant={variant} type="strong" text={label} />;
};

export default IntentProjectStateBadge;
